import { Skeleton } from "@circleco/compass/components/Skeleton";

export const ReportSkeleton = () => (
  <output aria-busy="true" aria-live="polite" className="flex flex-col gap-6">
    <div className="flex flex-col gap-2">
      <Skeleton className="h-4 w-2/3" />
      <Skeleton className="h-4 w-1/2" />
    </div>
    <Skeleton className="h-52 w-full" />
    <div className="flex flex-col gap-2">
      <Skeleton className="h-4 w-1/3" />
      <Skeleton className="h-3 w-full" />
      <Skeleton className="h-3 w-11/12" />
      <Skeleton className="h-3 w-3/4" />
    </div>
  </output>
);
